import { render } from "./appbarbuttons.vue?vue&type=template&id=2a4a5cb9&scoped=true"
import script from "./appbarbuttons.vue?vue&type=script&lang=js"
export * from "./appbarbuttons.vue?vue&type=script&lang=js"

import "./appbarbuttons.vue?vue&type=style&index=0&id=2a4a5cb9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4a5cb9"]])

export default __exports__